import React, { useEffect, useState, useMemo } from "react";
import { Table, Form, Pagination } from "react-bootstrap";
import { getUserInformationService } from "../../services/BondsServices";
import { USERS_TYPES, getUserTypeByRole, getRoleByUserType } from "../../types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";

const UserModal = ({ userIdentifier, existingUser, setUser, setSubmitted, onHide, lawFirm }) => {
  const [allUsers, setAllUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredUser, setFilteredUser] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);

  const isUserOAGOrLegalAssistant = identifier => {
    return false;
  };


  const [isSingleUser, setIsSingleUser] = useState(isUserOAGOrLegalAssistant(userIdentifier));
  const paginate = pageNumber => setCurrentPage(pageNumber);

  useEffect(() => {
    setItUserModalData(userIdentifier);
    fetchUsersData(getRoleByUserType(userIdentifier), lawFirm);
  }, []);

  useEffect(() => {
    if (existingUser && existingUser.length > 0) {
      setSelectedUser(existingUser);
    }
  }, [existingUser]);

  useEffect(() => {
    if (allUsers.length > 0) {
      const filtered = allUsers.filter((user) =>
        user.FirstName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        user.LastName.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredUser(filtered);
    }
  }, [allUsers, searchTerm]);

  const currentItems = useMemo(() => {
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    return filteredUser?.slice(indexOfFirstItem, indexOfLastItem);
  }, [currentPage, itemsPerPage, filteredUser]);

  const handleSelectUser = (user, single) => {
    if (single) {
      setSelectedUser([user]);
    } else {
      if (selectedUser.some(u => u.EmailID === user.EmailID)) {
        setSelectedUser(selectedUser.filter(u => u.EmailID !== user.EmailID));
      } else {
        setSelectedUser([...selectedUser, user]);
      }
    }
  };

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1);
  };

  const disAbleNullUserSelection = (selectedUser, userIdentifier) => {

    if (selectedUser.length == 0 && userIdentifier === USERS_TYPES.BOND_COUNSEL) {
      return true;
    } else {
      return false;
    }
  };

  const handleAddUser = () => {
    setUser(selectedUser);
    setSubmitted(false);
    onHide();
  };

  const fetchUsersData = async (user_role, law_firm) => {
    try {
      const userResponse = await getUserInformationService(user_role, law_firm);
      setAllUsers(userResponse[0]);
      setFilteredUser(userResponse[0]);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  const setItUserModalData = identifier => {
    setIsSingleUser(isUserOAGOrLegalAssistant(identifier));
  };

  return (
    <div>
      <div size="auto">
        <div className="selected-item-container">
          {selectedUser.length > 0 && selectedUser.map((user, index) => (

            <div className="selected-item"> <FontAwesomeIcon icon={faUser}></FontAwesomeIcon> {user.FirstName} {user.LastName}</div>
          ))}
        </div>
        <div>
          <Form.Control
            type="text"
            placeholder="Search by First name or Last name"
            value={searchTerm}
            onChange={handleSearch}
          />
          <br></br>
        </div>
        <h3>User Table</h3>
        <div>
          <Table className="modal-table" size="sm">
            <thead>
              <tr>
                <th style={{ width: "80px" }}></th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Email</th>
                {/* Add more columns as needed */}
              </tr>
            </thead>
            <tbody>
              {currentItems && currentItems?.length > 0 && currentItems?.map((user, index) => (
                <tr key={user.EmailID}>
                  <td>
                    <input
                      type="checkbox"
                      name="selectedUser"
                      value={user}
                      checked={selectedUser.some(u => u.EmailID === user.EmailID)}
                      onChange={() => handleSelectUser(user, isSingleUser)}
                    />
                  </td>
                  <td>{user.FirstName}</td>
                  <td>{user.LastName}</td>
                  <td>{user.EmailID}</td>
                  {/* Render additional user data */}
                </tr>
              ))}
            </tbody>
          </Table>
          <div className="d-flex justify-content-end">
            <Pagination className="float-end">
              <Pagination.Prev onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1} />
              <Pagination.Item>
                Page {currentPage} of {Math.ceil(filteredUser.length / itemsPerPage)}
              </Pagination.Item>
              <Pagination.Next onClick={() => paginate(currentPage + 1)} disabled={currentPage === Math.ceil(filteredUser.length / itemsPerPage)} />
            </Pagination>
          </div>
        </div>
        <div className="button-container right">
          <button
            type="button"
            className="btn btn-light"
            onClick={onHide}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleAddUser}
            disabled={disAbleNullUserSelection(selectedUser, userIdentifier)}
          >
            Select User
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserModal;